import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollEmployeeDataGeneralSettingsResponse } from '../types';

export const getEmployeeDataGeneralSettingsQuery = gql`
  query PayrollEmployeeDataGeneralSettings {
    payrollEmployeeDataGeneralSettings {
      data {
        employeeIds {
          mode
          employeeIdPrefix
          employeeIdLength
          enableSeparateContractorIdSeries
          contractorIdPrefix
        }
        employeeDirectory {
          enabled
        }
        payslip {
          showEmployeeId
          showBrandName
          showCompanyAddress
        }
        limits {
          maxEmployeeIdLength
          maxContractorIdPrefixLength
          maxLegacyCustomFields
        }
      }
      code
      success
      message
    }
  }
`;

export const getEmployeeDataGeneralSettings = () =>
  graphQLApi<PayrollEmployeeDataGeneralSettingsResponse, {}>({
    query: getEmployeeDataGeneralSettingsQuery,
    queryVariables: {},
  });
